/**
 * @flow
 * @relayHash 5607285562713e356168cde02d96d9d7
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type tradeOnboardingHelper_QueryResponse = {|
  +viewer: ?{|
    +user: ?{|
      +isVerifiedTrade: ?boolean;
      +profile: ?{|
        +email: ?string;
      |};
    |};
  |};
|};
*/


/*
query tradeOnboardingHelper_Query(
  $userId: String!
) {
  viewer {
    user(userId: $userId) {
      isVerifiedTrade: hasPermission(name: "B_NET_PRICE")
      profile {
        email
      }
      id
    }
    id
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "tradeOnboardingHelper_Query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "userId",
                "variableName": "userId",
                "type": "String!"
              }
            ],
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "isVerifiedTrade",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "name",
                    "value": "B_NET_PRICE",
                    "type": "String!"
                  }
                ],
                "name": "hasPermission",
                "storageKey": "hasPermission{\"name\":\"B_NET_PRICE\"}"
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "tradeOnboardingHelper_Query",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "tradeOnboardingHelper_Query",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "userId",
                "variableName": "userId",
                "type": "String!"
              }
            ],
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "isVerifiedTrade",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "name",
                    "value": "B_NET_PRICE",
                    "type": "String!"
                  }
                ],
                "name": "hasPermission",
                "storageKey": "hasPermission{\"name\":\"B_NET_PRICE\"}"
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query tradeOnboardingHelper_Query(\n  $userId: String!\n) {\n  viewer {\n    user(userId: $userId) {\n      isVerifiedTrade: hasPermission(name: \"B_NET_PRICE\")\n      profile {\n        email\n      }\n      id\n    }\n    id\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/utils/__generated__/tradeOnboardingHelper_Query.graphql.js